function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
var r = e(require("react")),
  t = e(require("react-attr-converter")),
  n = "#text",
  a = "#comment";
function o(e, t, u) {
  if (e.nodeName === n || e.nodeName === a) return e.value || e.nodeValue;
  var l = u.get(e.nodeName.toLowerCase()),
    s = i(e.attrs || e.attributes, t),
    c = l || e.tagName.toLowerCase();
  if (0 === e.childNodes.length) return r.createElement(c, s);
  for (var f = [], d = 0; d < e.childNodes.length; d++) f.push(o(e.childNodes[d], d, u));
  return r.createElement(c, s, f);
}
function i(e, r) {
  var n = {
    key: r
  };
  if (!e) return n;
  for (var a = 0; a < e.length; a++) {
    var o = t(e[a].name);
    n[o] = "style" === o ? (void 0, e[a].value.split(";").reduce(function (e, r) {
      if (r) {
        var t = r.split(":"),
          n = t[0].trim(),
          a = Array.from(n);
        Array.from(n).forEach(function (e, r) {
          "-" === e && (a[r + 1] = a[r + 1].toUpperCase(), a[r] = null);
        }), e[a.join("")] = t[1];
      }
      return e;
    }, {})) : e[a].value;
  }
  return n;
}
function u(e) {
  var r = new Map();
  return {
    convert: function convert(t) {
      if ("string" != typeof t) return null;
      var n = e.parseFragment(t);
      return n.childNodes.length > 0 ? function (e, r) {
        for (var t = [], n = 0; n < e.childNodes.length; n++) t.push(o(e.childNodes[n], n, r));
        return 1 === t.length ? t[0] : t;
      }(n, r) : null;
    },
    registerComponent: function registerComponent(e, t) {
      r.set(e.toLowerCase(), t);
    }
  };
}
var l = {
  parseFragment: function parseFragment(e) {
    return new DOMParser().parseFromString(e, "text/html").body;
  },
  serialize: function serialize(e) {
    return e.innerHTML;
  }
};
exports.ReactHTMLConverter = function () {
  return u(l);
}, exports.convertStatic = function (e) {
  return function (e, t) {
    if ("string" != typeof e) return null;
    var n = t.parseFragment(e);
    if (n.childNodes.length > 0) {
      var a;
      if (1 === n.childNodes.length) {
        var o = n.childNodes[0];
        a = r.createElement(o.nodeName.toLowerCase(), Object.assign({
          dangerouslySetInnerHTML: {
            __html: t.serialize(o)
          }
        }, i(o.attrs || o.attributes, 0)));
      } else a = r.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: e
        }
      });
      return a;
    }
    return null;
  }(e, l);
};